(() => {
  const els = document.querySelectorAll('.aeve-reveal');
  if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach((el) => el.classList.add('is-in'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach((e) => {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -10% 0px' });
  els.forEach((el) => io.observe(el));
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('.aeve-reveal').forEach((el) => el.classList.add('is-in')));
})();
